
import StickyHeader from '../../components/feature/StickyHeader';
import Hero from './components/Hero';
import UpcomingEvents from './components/UpcomingEvents';
import WhoThisIsFor from './components/WhoThisIsFor';
import CompetitiveEdge from './components/CompetitiveEdge';
import ValueProposition from './components/ValueProposition';
import ApplicationForm from './components/ApplicationForm';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <StickyHeader />
      <Hero />
      <UpcomingEvents />
      <WhoThisIsFor />
      <CompetitiveEdge />
      <ValueProposition />
      <ApplicationForm />
      <Footer />
    </div>
  );
}
